// extracted by mini-css-extract-plugin
export var clickableWrapper = "_1s-2";
export var placeholderIcon = "_1s-3";
export var thumbnailCanvas = "_1s-1";
export var thumbnailWrapper = "_1s-0";